import { FaPersonRunning, FaUserDoctor } from "react-icons/fa6";
import { FaRegClipboard, FaUserTie } from "react-icons/fa";
import { BiFemale, BiMale } from "react-icons/bi";

export const genderMap = () => [
    {id: "M", label: "Masculino", icon: BiMale},
    {id: "F", label: "Feminino", icon: BiFemale},
];

export const cardTypeMap = () => [
    {id: "CC", label: "Cartão de Cidadão"},
    {id: "PASSPORT", label: "Passaporte"},
];

export const maritalStatusMap = () => [
    {id: "SINGLE", label: "Solteiro"},
    {id: "MARRIED", label: "Casado"},
    {id: "DIVORCED", label: "Divorciado"},
    {id: "WIDOWED", label: "Viúvo"},
];

export const echelonMemberRoleMap = () => [
    {id: "PLAYER", label: "Atleta", plural: "Atletas", icon: FaPersonRunning, order: 0},
    {id: "COACH", label: "Treinador", plural: "Treinadores", icon: FaRegClipboard, order: 1},
    {id: "ASSISTANT", label: "Treinador Adjunto", plural: "Treinadores", icon: FaRegClipboard, order: 2},
    {id: "DIRECTOR", label: "Oficial", plural: "Oficiais", icon: FaUserTie, order: 3},
    {id: "PHYSIO", label: "Fisioterapeuta", plural: "Fisioterapeutas", icon: FaUserDoctor, order: 4},
];

export const echelonMemberPositionMap = () => [
    {id: "GK", acronym: "GR", label: "Guarda-Redes"},
    {id: "LW", acronym: "PE", label: "Ponta Esquerda"},
    {id: "LB", acronym: "LE", label: "Lateral Esquerdo"},
    {id: "CB", acronym: "CN", label: "Central"},
    {id: "RB", acronym: "LD", label: "Lateral Direito"},
    {id: "RW", acronym: "PD", label: "Ponta Direita"},
    {id: "CF", acronym: "PV", label: "Pivot"},
    {id: "UN", acronym: "UN", label: "Universal"},
];

export const paymentTypeMap = () => {
    return {
        MEMBERSHIP: "Sócio",
        ECHELON_MONTH: "Mensalidade",
        ECHELON_INIT: "Jóia",
        SHOP: "Loja",
        ECHELON_OTH: "Outros",
    }
};

export const paymentStatusMap = () => {
    return {
        SKIPPED: {color: "paymentSkipped", label: "Dispensado", real: true},
        PENDING: {color: "paymentMissing", label: "Em Falta", real: true},
        PAID: {color: "paymentPaid", label: "Pago", real: true},
        COMPLETED: {color: "paymentPaid", label: "Concluído", real: true},
        MULTIPLE: {color: "paymentMultiple", label: "Parcial", real: false},
        BLANK: {color: "paymentBlank", label: "Inexistente", real: false},
    }
}

export const orderStatusMap = () => {
    return [
        { id: "STATUS_00_REQUEST", label: "Pedido solicitado", isFinal: false },
        { id: "STATUS_01_ORDERED", label: "Encomendado ao Fornecedor", isFinal: false },
        { id: "STATUS_02_RESERVED", label: "Reservado", isFinal: false },
        { id: "STATUS_03_PROCESSING", label: "Em processamento", isFinal: false },
        { id: "STATUS_04_READY", label: "Pronto a Entregar", isFinal: false },
        { id: "STATUS_05_SHIPPED", label: "Enviado", isFinal: false },
        { id: "STATUS_06_DELIVERED", label: "Entregue", isFinal: false },
        { id: "STATUS_07_COMPLETED", label: "Concluído", isFinal: true },
        { id: "STATUS_08_RETURNED", label: "Devolvido", isFinal: false },
        { id: "STATUS_09_REFUNDED", label: "Reembolsado", isFinal: true },
        { id: "STATUS_99_CANCELLED", label: "Cancelado", isFinal: true },
    ]
}
